import { createStyles } from '@mantine/core';
import themeVariables from '@/styles/themeVariables';

export const useDiscoveryContentDetailModalStyle = createStyles(
  (theme, dark: any) => ({
    outerModalContainer: {
      maxHeight: '90dvh',
      marginTop: 40,
      [theme.fn.smallerThan('md')]: {
        maxHeight: '96dvh !important',
        width: '98dvw',
        marginTop: 0,
        placeSelf: 'center',
      },
    },

    modalContainer: {
      width: '100%',
      padding: 18,
      [theme.fn.smallerThan('md')]: {
        padding: '12px 0px',
      },
    },

    appModalContainer: {
      width: '100%',
    },

    headerContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: 10,
      width: '100%',
    },

    headerCloseButton: {
      padding: 4,
      borderRadius: '0.5rem',
      marginLeft: 'auto',
      [theme.fn.largerThan('md')]: {
        display: 'none',
      },
    },

    headerCloseButtonInSide: {
      padding: 4,
      borderRadius: '0.5rem',
      marginLeft: 'auto',
      [theme.fn.smallerThan('md')]: {
        display: 'none',
      },
    },

    headerUserInfoContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: 10,
      ':hover': {
        cursor: 'pointer',
      },
      border: `1px solid ${
        dark?.dark ? themeVariables.line.dark : themeVariables.colors.light300
      }`,
      borderRadius: '0.75rem',
      padding: '10px',
      margin: '15px 0 30px',
    },

    techstack: {
      borderRadius: '0.75rem',
    },

    headerUserProfileImage: {
      borderRadius: '50%',
      marginRight: 10,
    },

    headerFooterContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: 6,
      marginLeft: 5,
    },

    bodyContainer: {
      padding: '0px 0px 30px 0px',
      color: themeVariables.darkMode.normal(dark?.dark),
    },

    appBodyImageContainer: {
      width: '50%',
      marginBottom: 24,
      justifyContent: 'center',
      display: 'flex',
    },

    bodyImageContainer: {
      '&:hover': {
        '#overlay': {
          visibility: 'visible',
        },
      },
    },

    bodyImage: {
      objectFit: 'contain',
      borderRadius: 16,
      width: 480,
      height: 360,
      [theme.fn.smallerThan('md')]: {
        padding: 0,
        width: 360,
        height: 240,
      },
    },

    bodyImageOverlay: {
      position: 'absolute',
      visibility: 'hidden',
      cursor: 'pointer',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: 16,
      backdropFilter: 'blur(20px)',
      WebkitBackdropFilter: 'blur(20px)',
    },

    appBodyImage: {
      width: '100%',
      height: '100%',
      borderRadius: '0.75rem',
      objectFit: 'contain',
      border: `0.5px solid ${themeVariables.colors.light300}`,
    },

    appBodySummaryTitle: {
      display: 'flex',
      gap: 10,
      fontSize: 16,
      fontWeight: 700,
      color: themeVariables.fontColors.dark,
      textDecoration: 'underline',
      textUnderlineOffset: 8,
    },

    bodyText: {
      lineHeight: 2,
      overflow: 'hidden',
    },

    contentContainer: {
      paddingRight: 18,
      [theme.fn.smallerThan('md')]: {
        padding: 0,
      },
    },

    sideContainer: {
      padding: '0px 18px',
      borderLeft: `1px solid ${themeVariables.lineDark.light300(dark?.dark)}`,
      [theme.fn.smallerThan('md')]: {
        borderLeft: 'none',
        padding: '6px',
      },
    },

    sideContainerInner: {
      display: 'flex',
      position: 'sticky',
      top: 0,
      gap: 0,
      [theme.fn.smallerThan('md')]: {
        padding: 0,
      },
    },

    actionButtonContainer: {
      border: `1px solid ${themeVariables.lineDark.light300(dark?.dark)}`,
      borderRadius: '0.75rem',
      width: '100%',
      maxWidth: 600,
      margin: '20px auto 30px',
      cursor: 'pointer',
      [theme.fn.smallerThan('xs')]: {
        div: {
          flexDirection: 'column',
        },
      },
    },

    actionButton: {
      border: 'none',
      borderRight: `1px solid ${themeVariables.lineDark.light300(dark?.dark)}`,
      fontSize: 14,
      padding: '4px 0px',
      color: themeVariables.fontColors.light,
      fontWeight: 500,
      width: '100%',
      justifyContent: 'center',
      gap: 0,
    },

    modalBody: {
      width: 1200,
      maxWidth: '100%',
      [theme.fn.smallerThan('md')]: {
        margin: 0,
      },
      margin: 'auto',
    },
  })
);

export const useDiscoveryProfileListStyle = createStyles((theme, dark: any) => ({
  loadingContainer: {
    [theme.fn.smallerThan('sm')]: {
      marginTop: -20,
    },
  },

  cardContainer: {
    cursor: 'pointer',
    paddingBottom: 16,
    borderBottom: `1px solid ${themeVariables.lineDark.neutral(dark?.dark)}`,
    transition: '300ms all ease',
    ':hover': {
      transform: 'translateX(4px)',
    },
    marginBottom: 16,
    [theme.fn.smallerThan('sm')]: {
      borderBottom: 'none',
      paddingBottom: 0,
      marginBottom: 0,
      marginRight: 20,
    },
  },

  profileImage: {
    objectFit: 'cover',
    borderRadius: '50%',
    border: `1px solid ${themeVariables.line.shallow}`,
    [theme.fn.smallerThan('sm')]: {
      width: 40,
      height: 40,
    },
  },

  moreCardContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: 160,
    [theme.fn.smallerThan('sm')]: {
      width: 120,
    },
  },

  title: {
    fontSize: 22,
    fontWeight: 600,
    color: dark?.dark
      ? themeVariables.fontColors.white
      : themeVariables.fontColors.dark,
    lineHeight: '28px',
    [theme.fn.smallerThan('sm')]: {
      fontSize: 17,
      lineHeight: '24px',
    },
  },

  headerExtraInfoText: {
    fontSize: 14,
    fontWeight: 600,
    color: themeVariables.label.alternative,
    cursor: 'pointer',
    '&:hover': {
      color: themeVariables.fontColors.light,
      fontWeight: 700,
    },
  },

  arrowWrapper: {
    border: `1px solid ${themeVariables.line.normal}`,
    borderRadius: 6,
    width: 61,
    height: 28,
    display: 'flex',
    justifyContent: 'center',
    cursor: 'pointer',
  },

  arrowButton: {
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
  },

  profileName: {
    fontSize: 15,
    lineHeight: '22px',
    marginBottom: 4,
    fontWeight: 600,
    [theme.fn.smallerThan('sm')]: {
      fontSize: 14,
      lineHeight: '20px',
    },
  },

  profileJob: {
    fontSize: 13,
    lineHeight: '18px',
    [theme.fn.smallerThan('sm')]: {
      fontSize: 12,
      lineHeight: '16px',
    },
  },

  profileWrapper: {
    marginBottom: 35,
    marginTop: -4,
    [theme.fn.smallerThan('sm')]: {
      marginBottom: 18,
      display: 'none',
    },
  },

  mobileContainer: {
    display: 'none',
    [theme.fn.smallerThan('sm')]: {
      display: 'initial',
      marginTop: 1,
    },
  },

  desktopContainer: {
    display: 'initial',
    [theme.fn.smallerThan('sm')]: {
      display: 'none',
    },
  },
}));

export const useDiscoveryListPageCategoryMenuBarStyle = createStyles(
  (theme, dark: any) => ({
    menuItem: {
      padding: '0px 16px',
      borderRadius: '5rem',
      border: `1px solid ${
        dark?.dark ? themeVariables.line.dark : themeVariables.colors.light300
      }`,
      color: themeVariables.darkMode.normal(dark?.dark),
      cursor: 'pointer',
      gap: 12,
      marginRight: 8,
      fontSize: 15,
      fontWeight: 500,
      lineHeight: '22px',
      height: 36,
      [theme.fn.smallerThan('sm')]: {
        padding: '0px 12px',
        fontSize: 14,
        lineHeight: '20px',
        height: 32,
      },
      '&:hover': {
        color: themeVariables.colors.white,
        backgroundColor: themeVariables.colors.blue200,
        border: `1px solid ${themeVariables.line.normal}00`,
      },
    },

    activeMenuItem: {
      borderRadius: '5rem',
      cursor: 'pointer',
      gap: 12,
      backgroundColor: themeVariables.colors.blue200,
      border: `1px solid ${themeVariables.line.normal}00`,
      marginRight: 8,
      padding: '0px 16px',
      fontSize: 15,
      fontWeight: 500,
      lineHeight: '22px',
      height: 36,
      [theme.fn.smallerThan('sm')]: {
        padding: '0px 12px',
        fontSize: 14,
        lineHeight: '20px',
        height: 32,
      },
      '&:hover': {
        color: themeVariables.colors.white,
        backgroundColor: themeVariables.colors.blue200,
        border: `1px solid ${themeVariables.line.normal}00`,
      },
    },

    menuWrapper: {
      zIndex: 2,
      top: 0,
      position: 'initial',
      marginBottom: 32,
      [theme.fn.smallerThan('sm')]: {
        position: 'sticky',
        backgroundColor: dark?.dark
          ? themeVariables.colors.dark
          : 'rgba(255, 255, 255, 0.88)',
        backdropFilter: 'saturate(150%) blur(32px)',
        margin: '0px -16px 24px',
        padding: '12px 16px',
      },
    },
  })
);

export const createDiscoveryQuiz = createStyles((theme) => ({
  title: {
    fontSize: 16,
    fontWeight: 600,
    padding: 4,
    lineHeight: '24px',
  },

  optionCard: {
    cursor: 'pointer',
    padding: '12px 20px',
    borderRadius: '0.5rem',
    ':hover': {
      backgroundImage: 'linear-gradient(100deg, #c2e9ff33 10%, #f4ddff33 90%)',
    },
  },

  optionAnswerCard: {
    cursor: 'pointer',
    borderRadius: '0.5rem',
    border: `1px solid ${themeVariables.colors.light200}`,
    overflow: 'hidden',
    position: 'relative',
  },

  optionCardText: {
    fontSize: 14,
    fontWeight: 500,
  },

  answer: {
    fontSize: 16,
    padding: '5px 10px',
    borderRadius: 8,
    width: '100%',
    ':hover': {
      backgroundColor: themeVariables.colors.light100,
      cursor: 'pointer',
      color: themeVariables.colors.blue300,
      fontWeight: 500,
    },
  },

  interpretationWrapper: {
    gap: 6,
    alignItems: 'center',
    [theme.fn.smallerThan('sm')]: {
      flexDirection: 'column',
      alignItems: 'start',
    },
  },

  interpretation: {
    display: 'flex',
    margin: '4px 0px 0px 22px',
    fontSize: 13,
    lineHeight: '18px',
    gap: 8,
    [theme.fn.smallerThan('sm')]: {
      margin: '4px 0px 0px 4px',
    },
  },
}));

export const createDiscoveryModalStyles = createStyles((theme) => ({
  cardContainer: {
    padding: 18,
    [theme.fn.smallerThan('sm')]: {
      padding: 0,
    },
  },

  headerContainer: {
    display: 'flex',
    alignItems: 'center',
    letterSpacing: '-0.05em',
    columnGap: 16,
  },

  desktopShareButtonsContainer: {
    marginLeft: 'auto',
  },

  mobileShareButtonsContainer: {
    display: 'flex',
    margin: '60px 0px 20px',
  },

  mobileShareButtonsBackground: {
    margin: 'auto',
    backgroundColor: themeVariables.colors.light000,
    padding: 8,
    borderRadius: 30,
  },

  headerBoldTile: {
    fontSize: 32,
    fontWeight: 700,
    color: themeVariables.fontColors.dark,
    [theme.fn.smallerThan('sm')]: {
      fontSize: 27,
    },
  },

  headerTitle: {
    fontSize: 27,
    fontWeight: 400,
    margin: '12px 0px',
    color: themeVariables.fontColors.dark,
    [theme.fn.smallerThan('sm')]: {
      fontSize: 24,
    },
  },

  bodyContainer: {
    margin: '60px 0px 90px',
  },

  bodyVoteTitle: {
    fontSize: 16,
    padding: 10,
    fontWeight: 600,
    letterSpacing: '-0.05em',
  },

  commentContainer: {
    ':hover': {
      cursor: 'pointer',
    },
  },

  commentTitle: {
    fontSize: 16,
    fontWeight: 600,
    color: themeVariables.fontColors.extraDark,
  },

  addCommentContainer: {
    marginTop: -35,
  },

  addCommentTitle: {
    fontSize: 16,
    fontWeight: 600,
    margin: '40px 0px 20px',
    color: themeVariables.fontColors.extraDark,
  },

  addCommentButtonContainer: {
    textAlign: 'end',
    margin: '8px 0px',
  },
}));
